import { AlpineComponent } from '@alpinejs/csp';

const Button = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'button--visible' : '';
  }
});

export default Button;
